var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-map"},[_c('div',{staticClass:"map-container",style:({height: _vm.mapHeight})},[_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"route-map"}},[_c('span',{staticClass:"loading-text"},[_vm._v("Loading")])])
}]

export { render, staticRenderFns }